import React, { Fragment, useRef, useState } from 'react'
import Footer from '../../component/Other/Footer'
import Navbar from '../../component/Other/Navbar'
import Head from '../../component/Page/Head'
import SecContact from '../../component/Page/SecContact'
import SecTestimonial from '../../component/Page/SecTestimonial'
import { NavLink } from 'react-router-dom'

const About = () => {
    const video = useRef(null)
    const [play, setPlay] = useState(false)
    return (
        <Fragment>
            <div className="overflow-hidden">
                <div className="position-relative">
                    <Navbar />
                    <Head title={"About Us"} to={"About Us"} />
                </div>

                <section>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 order-lg-1 order-12 my-auto">
                                <h3 className='normal font__size--50 text__50-1024 text__50-sm text__50-xs quest'>Welcome to our heaven
                                    Bloom & Grow</h3>
                                <p className="normal font__size--14 text__14-1024 color__gray-1">At Bloom & Grow, we are passionate about plants and bringing the beauty of nature into people's homes and workplaces. Our plant shop has been serving the pontianak community for 12 years, and we pride ourselves on our extensive selection of high-quality plants and our commitment to excellent customer service.</p>
                                <p className="normal font__size--14 text__14-1024 color__gray-1 mb-0">Our knowledgeable staff are dedicated to helping our customers find the perfect plant for their needs, whether it's a low-maintenance succulent or a lush indoor tree. We also offer a range of plant care products and accessories to help our customers keep their plants healthy and thriving.</p>

                                <div className="row my-4">
                                    <div className="col-4 col-xl-3 pr-2">
                                        <div className="wrapper__wrap-about text-center">
                                            <h3 className='semi-bold font__size--24 text__24-1024'>12+</h3>
                                            <p className='mb-0 normal font__size--14 text__14-1024 text__14-mm-10 color__gray-1'>Year Experience</p>
                                        </div>
                                    </div>
                                    <div className="col-4 col-xl-3 px-2">
                                        <div className="wrapper__wrap-about text-center">
                                            <h3 className='semi-bold font__size--24 text__24-1024'>35+</h3>
                                            <p className='mb-0 normal font__size--14 text__14-1024 text__14-mm-10 color__gray-1'>Store</p>
                                        </div>
                                    </div>
                                    <div className="col-4 col-xl-3 pl-2">
                                        <div className="wrapper__wrap-about text-center">
                                            <h3 className='semi-bold font__size--24 text__24-1024'>321k+</h3>
                                            <p className='mb-0 normal font__size--14 text__14-1024 text__14-mm-10 color__gray-1'>Satisfied client</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center">
                                    <a href="#!" className="medium font__size--16 text__16-1024 btn__action btn btn__orange color__white shadow rounded__50 pointer">Shop Now</a>
                                    <NavLink to="/service" className="medium font__size--16 text__16-1024 btn__action btn btn__outlined--black color__black shadow ml-3 no__opacity h__white rounded__50 pointer">Our Service</NavLink>
                                </div>
                            </div>
                            <div className="col-lg-6 order-1 order-lg-12 mb-4 my-lg-auto text-center text-lg-right">
                                <img src="./../images/Group 39881.png" alt="" />
                            </div>
                        </div>
                    </div>
                </section>

                <section>
                    <div className="container">
                        <div className="text-center mb-5">
                            <h3 className='normal font__size--50 text__50-1024 text__50-sm text__50-xs quest'>Our Mission to Provide High-Quality Plants</h3>
                            <p className="normal font__size--14 text__14-1024 color__gray-1">At Bloom & Grow, we are passionate about plants and bringing the beauty of nature into people's homes and workplaces. Our plant shop has <br className='d-none d-lg-block' /> been serving the pontianaj community for 12 years, and we pride ourselves on our extensive selection of high-quality plants and our <br className='d-none d-lg-block' /> commitment to excellent customer service.</p>
                        </div>

                        <div className="wrapper__video-wrap big position-relative mt-4 mb-5">
                            {
                                !play ? <img src="./../images/_Play button.png" className="pointer play" onClick={() => {
                                    video.current.play()
                                    setPlay(!play)
                                }} alt="" /> : ""
                            }

                            <video ref={video} width="320" poster="./../images/Rectangle 3.png" height="240" controls>
                                <source src="./../images/03_oduvan_agro_hand_14_dut_oduvan_preview.mp4" type="video/mp4" />
                            </video>
                        </div>

                        <div className="d-flex align-items-center justify-content-center">
                            <a href="#!" className="medium font__size--16 text__16-1024 btn__action btn btn__orange color__white shadow rounded__50 pointer">Shop Now</a>
                            <NavLink to="/service" className="medium font__size--16 text__16-1024 btn__action btn btn__outlined--black color__black shadow ml-3 no__opacity h__white rounded__50 pointer">Our Service</NavLink>
                        </div>
                    </div>
                </section>

                <section className="position-relative">
                    <img src="./../images/sd (2).png" className="images__wrap-1" alt="" />
                    <img src="./../images/Clip path group (1).png" className="images__wrap-2" alt="" />
                    <div className="container position-relative z-2">
                        <div className="text-center mb-5">
                            <h3 className='normal font__size--50 text__50-1024 text__50-sm text__50-xs quest'>Who We Are: Bloom & Grow Team</h3>
                            <p className="normal font__size--14 text__14-1024 color__gray-1">At Bloom & Grow, we have a dedicated team of plant enthusiasts who are passionate about providing the best possible products and services <br className='d-none d-lg-block' /> to our customers. Our team members come from diverse backgrounds and bring a wealth of knowledge and experience to the table.</p>
                        </div>

                        <div className="row mb-4">
                            <div className="mb-4 mb-md-0 col-md-4 text-center">
                                <img src="./../images/ssy (1).png" className='mb-3' alt="" />
                                <h5 className='semi-bold font__size--24 text__24-1024'>Jane Doe</h5>
                                <p className='normal font__size--14 text__14-1024 color__gray-1'>Plant Specialist</p>
                            </div>
                            <div className="mb-4 mb-md-0 col-md-4 text-center">
                                <img src="./../images/ssy (2).png" className='mb-3' alt="" />
                                <h5 className='semi-bold font__size--24 text__24-1024'>John Smith</h5>
                                <p className='normal font__size--14 text__14-1024 color__gray-1'> Customer Service Manager</p>
                            </div>
                            <div className="mb-4 mb-md-0 col-md-4 text-center">
                                <img src="./../images/ssy (3).png" className='mb-3' alt="" />
                                <h5 className='semi-bold font__size--24 text__24-1024'>Michael Chen</h5>
                                <p className='normal font__size--14 text__14-1024 color__gray-1'>Operations Manager</p>
                            </div>
                        </div>

                        <div className="text-center">
                            <NavLink to="/team" className="medium font__size--16 text__16-1024 btn btn__outlined--black color__black shadow no__opacity h__white rounded__50 pointer">See All Our Team</NavLink>
                        </div>

                    </div>
                </section>

                <SecTestimonial ornamen={false} />

                <SecContact />

                <Footer />
            </div >
        </Fragment >
    )
}

export default About